export default __webpack_public_path__ + "static/media/terminate-1.24063790.png";